/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefundAccountDto } from '../../models/refund-account-dto';
import { RefundAccountResponseDto } from '../../models/refund-account-response-dto';

export interface UserControllerRegisterRefundAccount$Params {
      body: RefundAccountDto
}

export function userControllerRegisterRefundAccount(http: HttpClient, rootUrl: string, params: UserControllerRegisterRefundAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<RefundAccountResponseDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerRegisterRefundAccount.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RefundAccountResponseDto>;
    })
  );
}

userControllerRegisterRefundAccount.PATH = '/api/user/me/refund-account';
